
import { IPostCode } from '../store';
import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

@Component
export default class PostCodeMixin extends Vue {
  public postCode: IPostCode = {} as IPostCode;

  @Getter('postCode', { namespace: 'app/diagnostic' })
  protected postCodeStore!: IPostCode;

  protected created() {
    this.postCode = this.postCodeStore;
  }
}
